import { alertRequest, body, request } from "services/request";

const syncStatuses = "api/syncEntityStatuses";

const getLastSyncStatus = (type: string, id: number) =>
    request(`${syncStatuses}/get?entityType=${type}&entityId=${id}`, { method: "GET" });

const add = (params: {}) => alertRequest(`${syncStatuses}/add`, body(params));

export { getLastSyncStatus, add };
